<template>
  <div class="trust-bar nm-panel nm-panel--inset">
    <div class="trust-bar__inner">
      <table class="table nm-table nm-table--trust mb-0">
        <tbody>
          <tr>
            <td v-for="item in items" :key="item.label">
              <span class="trust-bar__text">
                <i :class="[item.icon, 'trust-bar__icon']" aria-hidden="true" />
                {{ item.label }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>

<style scoped>
.trust-bar__inner {
  padding: 1rem 1.25rem;
}

@media (min-width: 768px) {
  .trust-bar__inner {
    padding: 1.15rem 2rem;
  }
}
</style>